/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, {
  memo, useState, useCallback, useRef, useEffect,
} from 'react';
import classNames from 'classnames';
import { CONST_RETAIL_APPLICANT } from 'shared/constants/index';
import CheckIcons from 'assets/icons/check-icon.svg';
import './StatusDropdown.scss';

const { ONGOING, COMPLETED, CANCELLED } = CONST_RETAIL_APPLICANT.DROPDOWN;

interface Props {
  data?: [],
  defaultValue?: string
  onSelectChange?: ((event: React.ChangeEvent<HTMLInputElement>) => void) | undefined,
}

const StatusDropdown: React.FC<Props> = memo(({
  data = [ONGOING, COMPLETED, CANCELLED],
  onSelectChange = () => {}, defaultValue = data[0],
}) => {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const [isShowData, setShowData] = useState(false);
  const dropDownRef = useRef <HTMLUListElement>(null);
  const classes = classNames({
    statusDropdown: true,
    'statusDropdown--ongoing': value === ONGOING,
    'statusDropdown--completed': value === COMPLETED,
    'statusDropdown--cancelled': value === CANCELLED,
  });

  const handleClick = useCallback((val) => {
    setValue(val);
    onSelectChange(val);
    // eslint-disable-next-line
  }, [isShowData]);

  //* * Handle Click OutSide */
  const handleClickOutside = (event) => {
    if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
      setShowData(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  return (
    <button type="button" className={classes} onClick={() => setShowData(!isShowData)}>
      <span>{value}</span>
      {isShowData && (
      <ul className="statusDropdown__list" ref={dropDownRef}>
        {data.map((item, idx) => (
          <li
            className={item}
            key={`statusDropdown-${idx}`}
            onClick={() => handleClick(item)}
          >
            {item}
            <img src={CheckIcons} alt="icon" />
          </li>
        ))}
      </ul>
      )}
    </button>
  );
});

export default StatusDropdown;
